import ThumbDown from "@mui/icons-material/ThumbDown";
import ThumbDownOutlined from "@mui/icons-material/ThumbDownOutlined";
import ThumbUp from "@mui/icons-material/ThumbUp";
import ThumbUpOutlined from "@mui/icons-material/ThumbUpOutlined";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { FeedbackThumbs, Message } from "../../interfaces/sirius";

interface MessageFeedbackButtonProps {
  message: Message;
  handleFeedback: Function;
  thumbIconMode: FeedbackThumbs;
  className?: string;
  iconClassName?: string;
}

const MessageFeedbackButton: React.FC<MessageFeedbackButtonProps> = ({
  message,
  handleFeedback,
  thumbIconMode,
  className,
  iconClassName,
}) => {
  const ThumbUpIcon =
    message.feedback === FeedbackThumbs.THUMBS_UP ? ThumbUp : ThumbUpOutlined;
  const ThumbDownIcon =
    message.feedback === FeedbackThumbs.THUMBS_DOWN
      ? ThumbDown
      : ThumbDownOutlined;
  const IconComponent =
    thumbIconMode === FeedbackThumbs.THUMBS_UP ? ThumbUpIcon : ThumbDownIcon;

  return (
    <IconButton
      className={className}
      onClick={() => handleFeedback(message, thumbIconMode)}
    >
      <IconComponent className={iconClassName} />
    </IconButton>
  );
};

export default MessageFeedbackButton;
